import { PropertyUser } from '@/models/Property';
import { apiClient } from '@/services/api';
import { logger } from '@/utils/logger/loggerInstance';

export const getPropertyUsers = async (propertyId: string): Promise<PropertyUser[]> => {
  const url = `/properties/${propertyId}/users`;

  logger.debug(`GET ${url}`);
  const response = await apiClient.get<PropertyUser[]>(url);

  return response.data;
};
